<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 form-layout">
        <transition-group name="slide-fade">
            <div class="form-rows" key="venue-name" v-if="participant && (bookingItem || venue)">
                <div class="fields input readonly half left">
                    <label for="venue_name" v-html="$parent.locale.text_heading_venue"></label>
                    <input class="form-control" name="venue_name" id="venue_name" :value="bookingItem.venue_name + ' (' + bookingItem.venue_town + ')'" readonly>
                    <p v-if="package">{{ $parent.locale.text_change_venue }}, <a @click="changeVenue">click here</a>. {{ $parent.locale.text_change_venue_participant_warning }}</p>
                </div>
                <div class="fields input readonly half right" v-if="participant">
                    <label for="participant_name" v-html="$parent.locale.text_heading_participant"></label>
                    <input name="participant_name" id="participant_name" :value="participant.first_name + ' ' + participant.last_name" readonly>
                    <p v-if="package">{{ $parent.locale.text_change_participant }}, <a @click="changeParticipant">click here</a>. {{ $parent.locale.text_change_venue_participant_warning }}</p>
                </div>
            </div>
            <div class="form-rows form-section" v-if="selection.base && participant" key="individual_days">
                <package-selection :quick="true" :edit="true" :toSwap="$parent.booking_item" :days="true" :participant="participant" :quickSelection="selection"></package-selection>
            </div>
        </transition-group>
    </div>
</template>

<script>
    export default {
        props: ['participant', 'bookingItem', 'package', 'venue'],
        data () {
            return {
                selection: {
                    base: null,
                },
                programmes: [],
            }
        },
        methods: {
            changeVenue: function () {
                if(this.$route.params.hasOwnProperty('bookingId'))
                    axios.delete('/camp-booking/bookings/'+this.$route.params.bookingId+'/items/'+this.bookingItem.id)
                        .then(response => {
                            if(response.data.data.deleted == true)
                                window.location.href=venues_change_url;
                        })
                else
                    window.location.href=venues_change_url;
            },
            changeParticipant: function () {
				//Check see if we are editing, and have a booking ID, if so delete. If no booking ID go straight back to age selection.
                if(this.$route.params.hasOwnProperty('bookingId'))
                    axios.delete('/camp-booking/bookings/'+this.$route.params.bookingId+'/items/'+this.bookingItem.id)
                        .then(response => {
                            if(response.data.data.deleted == true) {
								this.$root.updateBasketCount();
                                this.$router.push({ name: 'booking.age', params: { venueId: (this.bookingItem ? this.bookingItem.venue_id : this.$route.params.venueId ) } })
							}
                        })
                else
                    this.$router.push({ name: 'booking.age', params: { venueId: (this.bookingItem ? this.bookingItem.venue_id : this.$route.params.venueId ) } })
            }
        },
        computed: {
            locale: function () {
                return this.$root.locale.basket.quick_add_edit;
            }
        },
        created () {
            var d = new Date();
            var day = d.getDay(),
            diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
            var first_day_of_week = new Date(d.setDate(diff));
            axios.get('camp-booking/packages', {
                params: {
                    price_per: 'day',
                    min_start_date: first_day_of_week.toISOString().split('T')[0], //now.toISOString().split('.')[0]
                    // age: (new Date(this.participant.dob)).getAge(),
                    venue_id: this.$route.params.venueId,
                    only_base_packages: true.toString(),
                    hide_internal: true
                }
            }).then(response => {
                var ids = [];
                this.programmes = response.data.data.filter(item => {
                    if(ids.indexOf(item.package_template_id) > -1)
                        return false

                    ids.push(item.package_template_id);
                    return true;
                });

                /**
                 * Display an error if there are no packages available
                 */
                 if(this.programmes.length == 0) {
                    this.$root.alert(this.locale.text_empty_individual_days, 'danger', 3000);
                }

                /**
                 * Showing the available dates if there's only a single package available
                 */
                if(this.programmes != undefined) {
                    this.selection.base = this.programmes[0];
                }
            });
        },
        components: {
            'package-selection': require('../../builder/PackageOptions.vue')
        }
    }
</script>



// WEBPACK FOOTER //
// IndividualDays.vue?6a5f735d